<div class="horizontalMenucontainer">
  <div class="page">
    <div class="page-main">
      <app-header [isHomeRoute]="isHomeRoute"></app-header>
      <div class="app-content main-content" [class.main-content--offset]="!isHomeRoute" [class.main-content--home]="isHomeRoute">
        <app-breadcrumb></app-breadcrumb>
        <div>
          <router-outlet><app-loader></app-loader></router-outlet>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
